'use client';
/** @jsxImportSource @emotion/react */

import type { AutocompleteProps } from '@mui/material/Autocomplete';

import MuiAutocomplete from '@mui/material/Autocomplete';

import { CoreIcon } from '../core-icon/CoreIcon';

export type { AutocompleteProps };
export const Autocomplete: typeof MuiAutocomplete = (props) => {
  return (
    <MuiAutocomplete popupIcon={<CoreIcon name="chevrondown" />} {...props} />
  );
};
